import React, { useState, useEffect } from 'react'
import {
  Panel,
  Button,
  Message,
  Grid,
  Row,
  Col,
  Container,
  Header,
  Content,
  Footer,
  Sidebar,
  Table,
  Icon,
  FlexboxGrid,
  IconButton,
} from 'rsuite'

export default function ApproverDetailWidgets({ dataList, header }) {
  // const [formSchema, setFormSchema] = useState(schema)
  const { Column, HeaderCell, Cell } = Table
console.log(dataList)
  return (
    <>
      <Panel
        className="grantee-profile-info"
        shaded
        header={header}
        bordered
        collapsible
        defaultExpanded
        style={{ marginBottom: 10 }}
      >
        <Table height={300} data={dataList} worWrap>
          {/* <Column width={60} align="center">
            <HeaderCell>
              <span>ลำดับ</span>
            </HeaderCell>
            <Cell dataKey="approveLevel" />
          </Column> */}

          <Column width={155}>
            <HeaderCell>
              <span>สิทธิ์การอนุมัติ</span>
            </HeaderCell>
            <Cell dataKey="approveLevelName" />
          </Column>

          <Column width={250}>
            <HeaderCell>
              <span>ชื่อ-สกุล</span>
            </HeaderCell>
            <Cell dataKey="fullName" />
          </Column>
          <Column minWidth={250} flexGrow={1}>
            <HeaderCell>
              <span>ตำแหน่ง</span>
            </HeaderCell>
            <Cell dataKey="position" />
          </Column>
        </Table>
      </Panel>
    </>
  )
}
